'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002e$002dString$002dParsers$0024 from "./scala.collection.-String-Parsers$.js";
import * as $j_scala$002eutil$002e$002dLeft from "./scala.util.-Left.js";
import * as $j_scala$002eutil$002e$002dRight from "./scala.util.-Right.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$() {
}
export { $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ as $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ };
$p = $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$() {
}
export { $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ as $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ };
$h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$.prototype = $p;
$p.jx = (function(str) {
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var this$3 = $j_scala$002ecollection$002e$002dString$002dParsers$0024.$m_sc_StringParsers$();
  var this$5 = (this$3.Bd(str) ? new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$m_jl_Double$().xS(str)) : $j_java$002elang$002e$002dObject.$m_s_None$());
  return (this$5.k() ? new $j_scala$002eutil$002e$002dLeft.$c_s_util_Left("Not a double") : new $j_scala$002eutil$002e$002dRight.$c_s_util_Right(this$5.C()));
});
var $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$, "dev.cheleb.scalamigen.Validator$given_Validator_Double$", ({
  jk: 1,
  bn: 1
}));
export { $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ as $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ };
var $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$;
function $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$() {
  if ((!$n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$)) {
    $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ = new $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$();
  }
  return $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$;
}
export { $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ as $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$ };
